export const IMAGE_CONSTANTS = {
    minHeight: 2304,
    minWidth: 3074,
    countryListForImageValidation: ["India"]
};
